export default __webpack_public_path__ + "static/media/login.609f6222.png";